/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  GenericNameServiceRefStorage,
  GenericNameServiceRefStorageInterface,
} from "../../../../contracts/dependant/nameServiceRef/GenericNameServiceRefStorage";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "nameService_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
] as const;

const _bytecode =
  "0x6080604052348015600f57600080fd5b5060405160c838038060c8833981016040819052602a91604e565b600080546001600160a01b0319166001600160a01b0392909216919091179055607c565b600060208284031215605f57600080fd5b81516001600160a01b0381168114607557600080fd5b9392505050565b603f8060896000396000f3fe6080604052600080fdfea264697066735822122052d9226d75e3955edcb12f28e80a2baac644976578ef5a095fbfb588ceaaed7664736f6c63430008110033";

type GenericNameServiceRefStorageConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GenericNameServiceRefStorageConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GenericNameServiceRefStorage__factory extends ContractFactory {
  constructor(...args: GenericNameServiceRefStorageConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    nameService_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<GenericNameServiceRefStorage> {
    return super.deploy(
      nameService_,
      overrides || {}
    ) as Promise<GenericNameServiceRefStorage>;
  }
  override getDeployTransaction(
    nameService_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(nameService_, overrides || {});
  }
  override attach(address: string): GenericNameServiceRefStorage {
    return super.attach(address) as GenericNameServiceRefStorage;
  }
  override connect(signer: Signer): GenericNameServiceRefStorage__factory {
    return super.connect(signer) as GenericNameServiceRefStorage__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GenericNameServiceRefStorageInterface {
    return new utils.Interface(_abi) as GenericNameServiceRefStorageInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GenericNameServiceRefStorage {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as GenericNameServiceRefStorage;
  }
}
